var exports = {
  "zr": "MacPermissionsSettingsRow.module__root___amQ3bV",
  "h_": "MacPermissionsSettingsRow.module__description___amQ3bV",
  "Mn": "MacPermissionsSettingsRow.module__lines___amQ3bV",
  "n8": "MacPermissionsSettingsRow.module__line___amQ3bV",
  "Om": "MacPermissionsSettingsRow.module__dot___amQ3bV",
  "Yf": "MacPermissionsSettingsRow.module__dotAllowed___amQ3bV",
  "H0": "MacPermissionsSettingsRow.module__dotDenied___amQ3bV",
  "Pf": "MacPermissionsSettingsRow.module__label___amQ3bV",
  "ZY": "MacPermissionsSettingsRow.module__trailing___amQ3bV",
  "XI": "MacPermissionsSettingsRow.module__action___amQ3bV",
  "TQ": "MacPermissionsSettingsRow.module__allowed___amQ3bV",
  "IR": "MacPermissionsSettingsRow.module__screenReaderOnly___amQ3bV",
  "v9": "MacPermissionsSettingsRow.module__advice___amQ3bV",
};

module.exports = exports;
